import { defineSlotRecipe } from '@chakra-ui/react';
import { switchAnatomy } from '@chakra-ui/react/anatomy';

export default defineSlotRecipe({
  slots: switchAnatomy.keys(),
  variants: {
    variant: {
      solid: {
        control: {
          _checked: {
            bg: 'primary.500',
          },
          bg: 'gray.500',
        },
      },
    },
  },
});
